import { apiClient } from './client'
import type {
  CommunityDetail,
  CommunityMembership,
  CommunitySummary,
  CreateCommunityRequest,
  PageResponse,
  UpdateCommunityRequest,
} from './types'

/** Phase 19 — Communities (subapps) API client. */

export const listCommunities = async (
  page: number = 0,
  size: number = 20
): Promise<PageResponse<CommunitySummary>> => {
  const response = await apiClient.get<PageResponse<CommunitySummary>>('/api/v1/communities', {
    params: { page, size },
  })
  return response.data
}

export const getCommunity = async (slug: string): Promise<CommunityDetail> => {
  const response = await apiClient.get<CommunityDetail>(
    `/api/v1/communities/${encodeURIComponent(slug)}`
  )
  return response.data
}

export const createCommunity = async (data: CreateCommunityRequest): Promise<CommunityDetail> => {
  const response = await apiClient.post<CommunityDetail>('/api/v1/communities', data)
  return response.data
}

export const updateCommunity = async (
  slug: string,
  data: UpdateCommunityRequest
): Promise<CommunityDetail> => {
  const response = await apiClient.patch<CommunityDetail>(
    `/api/v1/communities/${encodeURIComponent(slug)}`,
    data
  )
  return response.data
}

export const joinCommunity = async (slug: string): Promise<void> => {
  await apiClient.post(`/api/v1/communities/${encodeURIComponent(slug)}/join`)
}

export const leaveCommunity = async (slug: string): Promise<void> => {
  await apiClient.delete(`/api/v1/communities/${encodeURIComponent(slug)}/leave`)
}

export const listMyCommunities = async (): Promise<CommunityMembership[]> => {
  const response = await apiClient.get<CommunityMembership[]>('/api/v1/me/communities')
  return response.data
}
